import { AnalyticsBrowser } from '@segment/analytics-next'
const writeKey = process.env.SEGMENT_WRITE_KEY
if (!writeKey) {
  throw new Error('SEGMENT_WRITE_KEY is not set')
}
export const segmentAnalytics = AnalyticsBrowser.load({ writeKey })
